import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Nav, Button } from "react-bootstrap";
import { Tags } from './Tags';
import { Favourites } from './Favourites';
import { ArrowLeftIcon, MenuIcon } from "../../Icons/icons.component";
import ConceptLogo from "../../../assets/images/conceptbiu-logo.png";

const Index = () => {
  const TAGS = "tags";
  const FAVOURITES = "favourites";
  const { tabName } = useParams();
  const [showAddTagModal, setShowAddTagModal] = useState(false);
  const history = useHistory();

  const showModal = () => {
    setShowAddTagModal(true);
  };

  const handleTabClick = (tab) => {
    history.push(`/tags_favourites/${tab}`);
  };

  return (
    <div
      className={
        tabName === FAVOURITES
          ? "mainContainer tagsContainer favFeedsContainer"
          : "mainContainer tagsContainer"
      }
    >
      <div className="dashboardHeader dashboardHeaderWithTabs">
        <div className="dashboardHeaderTop d-flex">
          <div className="dashboardMobileMenu">
            <button className="btn menuBtn" id="menuBtn">
              <MenuIcon />
            </button>
            <img src={ConceptLogo} width="32" height="32" />
          </div>
          <div className="dhLeft d-flex">
            <div className="dhLeftWrap d-flex align-items-center">
              <h1>
                {/* <span className="arrowLeft" onClick={ () => window.history.back() }>
                  <ArrowLeftIcon />
                </span> */}
                Tags & Favourites
              </h1>
            </div>
          </div>
          {
            tabName == TAGS && (
              <Button onClick={() => showModal(true)} className="btn btnBlue addTagBtn">
                Add Tag
              </Button>
            )
          }
        </div>
        <div className="mobTopHeading">
          <h1>Tags & Favourites</h1>
        </div>
        <div className="dashboardTopTabs">
          <div className="dttLeft">
            <Nav variant="tabs" defaultActiveKey={tabName}>
              <Nav.Item>
                <Nav.Link
                  eventKey={TAGS}
                  onClick={() => handleTabClick(TAGS)}
                >
                  Tags
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  eventKey={FAVOURITES}
                  onClick={() => handleTabClick(FAVOURITES)}
                >
                  Favourite Feeds
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          {
            tabName == TAGS && (
              <div className="dttRight">
                <Button onClick={() => showModal(true)} className="btn btnBlue addTagBtn">
                  Add Tag
                </Button>
              </div>
            )
          }
        </div>
      </div>
      <div
        className={
          tabName === FAVOURITES
            ? "tagsMiddleSection favFeedsMiddleSection"
            : "tagsMiddleSection"
        }
      >
        {tabName === TAGS && (
          <Tags
            showAddTagModal={showAddTagModal}
            showModal={showModal}
            setShowAddTagModal={setShowAddTagModal}
          />
        )}

        {tabName === FAVOURITES && (
          <Favourites vertical={tabName} />
        )}
      </div>
    </div>
  );
};

export default Index;
